import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../components/sidebar/Sidebar';
import Profile from '../../components/Profile';
import Search from '../../components/Search';
import Button from '../../components/Button';
import LoadingTable from '../../components/LoadingTable';
import InfoBox from '../../components/InfoBox';
import Table from '../../components/wali-kelas/Table';
import {getWaliKelas, importWaliKelas, resetTableWaliKelas, updateStateWaliKelas} from '../../features/waliKelasSlice';
import searchIcon from '../../assets/icons/search-icon.svg';
import '../../styles/css/Karyawan.css';
import Tabbar from "../../components/Tabbar";
import {setCurrentKategori, setKategoriId} from "../../features/ketegoriSlice";
import {updateStateSiswa} from "../../features/siswaSlice";
import Filter from "../../components/student/Filter";
import Download from "../../components/student/Download";
import {getKaryawan, importPenilaian} from "../../features/karyawanSlice";
import {updateStateJurnalSiswa} from "../../features/jurnalSiswaSlice";

let kategoriAll = [
    {id: 'all', kategori: 'Semua WaliKelas'},
]

const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'

function WaliKelas() {
    const dispatch = useDispatch();
    const {
        isLoading,
        search,
        statusResApi,
        messageResApi,
        isDisplayMessage,
        listKelas
    } = useSelector((state) => state.waliKelas);

    const [showModal, setShowModal] = useState(false)
    const [file, setFile] = useState(null)
    const inputFileRef = useRef(null)

    useEffect(() => {
        dispatch(resetTableWaliKelas());
        dispatch(getWaliKelas({}));
    }, [dispatch]);

    function handleSearch() {
        dispatch(getWaliKelas({ search }));
        dispatch(updateStateWaliKelas({ name: 'currentPage', value: 1 }));
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') handleSearch();
    }


    function handleChange(e) {
        e.preventDefault();
        setShowModal(true)
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    }

    function handleImport() {
        dispatch(importWaliKelas(file))
            .then((res) => {
                if (res.meta.requestStatus === "fulfilled") {
                    setShowModal(false)
                    dispatch(getWaliKelas({}))
                    inputFileRef.current.value = '';
                }
            })
    }

    return (
        <div className='wrapper-karyawan'>
            <Sidebar />
            <div className='karyawan'>


                {showModal &&
                    <div className='bg-modal'>
                        <div className='alert-modal'>
                            <h1>Import WaliKelas</h1>
                            <p>Apakah anda yakin ?</p>
                            <div>
                                <button onClick={() => setShowModal(false)}>Tidak</button>
                                <button onClick={handleImport}>Iya</button>
                            </div>
                        </div>
                    </div>
                }


                <div className='search-and-profile'>

                    <div className={'wrap-search'}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 300, marginRight: 16 }}>
                            <span style={{ color: GREY, fontSize: 14 }}>🔍</span>
                            <input
                                type="text"
                                placeholder="Cari guru"
                                value={search}
                                onKeyDown={handleKeyDown}
                                onChange={(e) => dispatch(updateStateWaliKelas({ name: 'search', value: e.target.value }))}
                                style={{ border: 'none', outline: 'none', fontSize: 14, color: '#A6A6A6', flex: 1 }}
                            />
                        </div>



                        <button
                            className='btn-search'
                            style={{ background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 48 }}
                            onClick={handleSearch}
                        >
                            <img src={searchIcon} alt="" />
                        </button>
                    </div>
                    <Profile />
                </div>



                <div className='title-btn'>
                    <h1>Wali Kelas</h1>
                    <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>

                        <div className='right-header'>
                            <Button
                                style={{
                                    width: "150px",
                                    height: "45px"
                                }}
                                text={'Import Wali Kelas'}
                                onClick={() => inputFileRef.current.click()}
                            />
                            <input
                                style={{display: 'none'}}
                                ref={inputFileRef}
                                type="file"
                                onChange={handleChange}
                                accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
                            />
                        </div>
                        <Link to='/wali-kelas/add'>+ Add New</Link>
                    </div>
                </div>

                <div className='tabbar-filter'>
                    <Tabbar
                        options={[...kategoriAll]}
                        setKategoriId={setKategoriId}
                        setCurrentKategori={setCurrentKategori}
                        searchParams={''}
                        setKeterangan={updateStateSiswa}
                        path='/siswa'
                        sttic={true}

                    />

                    <div className='filter-angka'>
                        <Filter
                            option={listKelas}
                            setState={updateStateSiswa}
                            // onFilterChange={handleFilterChange}
                        />
                        <Download />

                    </div>
                </div>


                {isLoading
                    ? <LoadingTable size='large' />
                    : <Table />
                }

                <InfoBox
                    message={messageResApi}
                    status={statusResApi}
                    isDisplay={isDisplayMessage}
                    setIsDisplay={updateStateWaliKelas}
                    stateName='isDisplayMessage'
                />
            </div>
        </div>
    );
}

export default WaliKelas;
